var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "free-icon-phone-call-5585562 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7437 13.8144C14.6508 13.9071 14.5386 14.0256 14.4198 14.151C14.1232 14.4658 13.7526 14.8571 13.5204 15.0158C12.2985 15.8509 10.6637 15.4513 9.50736 14.9695C7.98195 14.3339 6.32119 13.1623 4.83001 11.6708C3.33744 10.1793 2.16603 8.51791 1.53046 6.9933C1.04923 5.83665 0.648852 4.20148 1.48397 2.9792C1.64256 2.74678 2.03479 2.37678 2.34917 2.07958C2.47495 1.96107 2.59252 1.8491 2.68549 1.75643C2.85053 1.5922 3.07389 1.5 3.30672 1.5C3.53955 1.5 3.76291 1.5922 3.92796 1.75643L6.17628 4.00422C6.34041 4.16926 6.43255 4.39257 6.43255 4.62535C6.43255 4.85812 6.34041 5.08143 6.17628 5.24648L5.5638 5.85775C5.35926 6.06081 5.22575 6.3245 5.18314 6.60956C5.14053 6.89462 5.1911 7.18582 5.32732 7.43982C6.16973 9.02989 7.47027 10.3303 9.06039 11.1725C9.31432 11.3087 9.60545 11.3592 9.89041 11.3165C10.1754 11.2738 10.4389 11.1402 10.6418 10.9356L11.2528 10.3243C11.4178 10.1601 11.6412 10.0679 11.874 10.0679C12.1069 10.0679 12.3302 10.1601 12.4953 10.3243L14.7437 12.5725C14.9079 12.7374 15 12.9607 15 13.1934C15 13.4262 14.9079 13.6495 14.7437 13.8144Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterPhone);
export default __webpack_public_path__ + "static/media/footer-phone.81823b7282e9b03bc32859c70ee6eec8.svg";
export { ForwardRef as ReactComponent };